function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M53.833 8H11.1663C8.22501 8 5.83301 10.392 5.83301 13.3333V50.6667C5.83301 53.608 8.22501 56 11.1663 56H53.833C56.7743 56 59.1663 53.608 59.1663 50.6667V13.3333C59.1663 10.392 56.7743 8 53.833 8ZM11.1663 50.6667V13.3333H29.833V50.6667H11.1663ZM35.1663 50.6667V13.3333H53.833L53.8357 50.6667H35.1663Z",
  fill: "#365DE6",
  fillOpacity: 0.5
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M40.5 18.6667H48.5V24.0001H40.5V18.6667ZM40.5 29.3334H48.5V34.6667H40.5V29.3334Z",
  fill: "#365DE6",
  fillOpacity: 0.5
});
const SvgLayout = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLayout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/layout.179e1c7d.svg";
export { ForwardRef as ReactComponent };